import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { livechatBaseUrl } from '../../constants/appConstants';
import { getTempTokenFromLocalStorage, getTokenFromLocalStorage } from '../../utils/helper';

const checkConnectivity = () => {
  return navigator.onLine;
};

export const livechatApiSlice = createApi({
  reducerPath: 'livechatApi',
  baseQuery: fetchBaseQuery({
    baseUrl: livechatBaseUrl,
    prepareHeaders: (headers) => {
      if (checkConnectivity()) {
        headers.set('Accept', 'application/json');
        headers.set(
          'Authorization',
          `Bearer ${getTokenFromLocalStorage() || getTempTokenFromLocalStorage()}`
        );
        return headers;
      } else {
        throw new Error('No internet connection');
      }
    },
  }),
  tagTypes: [
    'brands',
    'brandAdmin',
    'sessions',
    'tickets',
    'messages',
    'botQuestions',
    'agents',
    'roles',
    'auditLogs',
    'contacts',
  ],
  endpoints: () => ({}),
});
